import React from 'react';
import { useTranslation } from 'react-i18next';

import SelectSimple from '../SelectSimple';

const GenderSelect = (props) => {
    const { t } = useTranslation('ui');

    return (
        <SelectSimple
            options={[
                { label: t('GenderSelect.man'), value: 'male' },
                { label: t('GenderSelect.woman'), value: 'female' },
            ]}
            {...props}
        />
    );
};

export default GenderSelect;
